import React from 'react';
import { useHistory } from 'react-router-dom';
import PageHeading from '../ReusableComponents/PageHeading';
import InstitutionForm from '../MinhaOrganizadora/InstitutionForm';
import '../ReusableComponents/ModulePage.css';
import '../PortalAluno/portal.css';
import '../MinhaOrganizadora/OrganizationLogo.css';

const organization = { can_edit: true, can_enable_portal: true, can_edit_owner: true, change_text: true };
export default function CriarOrganizadora() {
  const history = useHistory();
  return <div className="module-page portal-admin">
    <section className="card module-card hidethis"><div className="card-body">
      <PageHeading title="Cadastrar organizadora" description="Defina a identificação, os contatos e a identidade visual da organizadora." icon="organizations" />
    </div></section>
    <section className="card module-card module-content"><div className="card-body">
      <h2 className="module-details-title">Dados da organizadora</h2>
      <InstitutionForm organization={organization} creating backTo="/organizadoras" onSaved={() => history.push('/organizadoras')} />
    </div></section>
  </div>;
}
